import React from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase';
import { DashIcon, CalendarIcon, PlusIcon, BarChartIcon, LogOutIcon, UserIcon } from './AdminIcons';

const LINKS = [
  { id: 'dashboard',    label: 'Dashboard',      Icon: DashIcon },
  { id: 'appointments', label: 'Appointments',   Icon: CalendarIcon },
  { id: 'calendar',     label: 'Calendar View',  Icon: CalendarIcon },
  { id: 'add',          label: 'Add Booking',    Icon: PlusIcon },
  { id: 'clients',      label: 'Client History', Icon: UserIcon },
  { id: 'analytics',    label: 'Analytics',      Icon: BarChartIcon },
];

export default function Sidebar({ active, setPage }) {
  const logout = async () => { await signOut(auth); window.location.reload(); };

  return (
    <div className="admin-sidebar">
      <div style={{ padding:'24px 20px', borderBottom:'1px solid rgba(255,255,255,0.05)', flexShrink:0 }}>
        <div style={{ display:'flex', alignItems:'center', gap:'10px' }}>
          <div style={{ width:'40px', height:'40px', background:'white', borderRadius:'50%', overflow:'hidden', flexShrink:0 }}>
            <img src="/images/logo.jpg" alt="" style={{ width:'100%', objectFit:'contain' }} />
          </div>
          <div>
            <div style={{ fontFamily:'Cormorant Garamond,serif', color:'white', fontWeight:700, fontSize:'0.95rem', lineHeight:1.1 }}>Eye-Sight</div>
            <div style={{ fontSize:'0.58rem', color:'#C8A96E', letterSpacing:'0.15em', textTransform:'uppercase' }}>Admin Portal</div>
          </div>
        </div>
      </div>

      <nav style={{ flex:1, padding:'16px 12px', overflowY:'auto' }}>
        {LINKS.map(({ id, label, Icon }) => {
          const on = active === id;
          return (
            <button key={id} onClick={() => setPage(id)} style={{
              width:'100%', display:'flex', alignItems:'center', gap:'12px',
              padding:'11px 14px', borderRadius:'6px', marginBottom:'3px',
              background: on ? 'rgba(200,169,110,0.12)' : 'transparent',
              border: on ? '1px solid rgba(200,169,110,0.2)' : '1px solid transparent',
              color: on ? '#C8A96E' : 'rgba(255,255,255,0.5)',
              cursor:'pointer', textAlign:'left',
              fontFamily:'Jost,sans-serif', fontSize:'0.84rem',
              fontWeight: on ? 500 : 400,
            }}>
              <Icon s={17} />{label}
            </button>
          );
        })}
      </nav>

      <div style={{ padding:'12px', borderTop:'1px solid rgba(255,255,255,0.05)', flexShrink:0 }}>
        <button onClick={logout} style={{ width:'100%', display:'flex', alignItems:'center', gap:'12px', padding:'11px 14px', borderRadius:'6px', background:'transparent', border:'1px solid transparent', color:'rgba(255,255,255,0.35)', cursor:'pointer', fontFamily:'Jost,sans-serif', fontSize:'0.84rem' }}>
          <LogOutIcon s={17} />Sign Out
        </button>
      </div>
    </div>
  );
}
